// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"df9feaea","453":"aeddc980"}[chunkId] + ".chunk.js";
};